/** @format */

import React, { useState } from 'react';
import { Radio } from 'antd';
import Images from '../../../../components/Commons/Images';
import { ENV_IMG } from '../../../../components/Commons/Hooks/Variables/Enviroment';

import './style.scss';

export default function PaymentCard(props) {
	const [isHovered, setIsHovered] = useState(false);

	const isChecked = props.paymentSelected === props.paymentMethod;

	const isDisabled = !props.active || (props.isPaymentExcedent && props.isPaymentExcedent.cover_payment);

	let radioContainerClass = 'ph-payment-radio-inner-container';
	if (isDisabled) {
		radioContainerClass += ' ph-payment-radio-border-disabled ph-payment-radio-inner-container-disabled';
	} else if (isChecked || isHovered) {
		radioContainerClass += ' ph-payment-radio-border-active';
	}

	return (
		<div className="ph-payment-card-main-container">
			{isDisabled && <div className="ph-payment-card-disable-container"></div>}

			{!props.available && (
				<div className="ph-payment-card-no-available-container">
					<Images
						classContent={'ph-payment-card-no-available-image-container'}
						classImage={`ph-payment-card-no-available-image`}
						default={`${ENV_IMG}/bag/bolsa-triste.png`}
						alt={'Promotion'}
						title={'Promotion'}
					/>
					<h4 className="ph-payment-card-no-available-title">Deshabilitado temporalmente</h4>
					<h4 className="ph-payment-card-no-available-subtitle">Volvemos en un momento.</h4>
				</div>
			)}

			<Radio
				className={radioContainerClass}
				value={props.paymentMethod}
				checked={isChecked}
				disabled={isDisabled || !props.available}
				onClick={() => {
					if (!isDisabled && props.available) {
						props.selectPayment(props.paymentMethod);
					}
				}}
				onMouseEnter={() => !isDisabled && setIsHovered(true)}
				onMouseLeave={() => setIsHovered(false)}
			>
				<div className="ph-payment-radio-select-container">
					<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<Images
							classImage={`${isDisabled ? 'ph-payment-methods-image-disable' : ''} ph-payment-methods-image`}
							default={props.image}
							alt={props.name}
							title={props.name}
						/>
						<div style={{ fontWeight: '400', fontSize: '14px', lineHeight: '20px' }}>{props.name}</div>
					</div>

					{props.name === 'Mercado Pago' && <div className="ph-payment-card-mp-description">Billetera virtual, tarjeta de crédito, débito y transferencia</div>}

					{props.paymentMethod === props.isDiscountName && (
						<div className="ph-payment-card-discount-container">
							<Images
								classImage={`ph-payment-card-discount-image`}
								webp={`${ENV_IMG}/react-promotion/promotion-icon.webp`}
								jp2={`${ENV_IMG}/react-promotion/promotion-icon.jp2`}
								jxr={`${ENV_IMG}/react-promotion/promotion-icon.jxr`}
								default={`${ENV_IMG}/react-promotion/promotion-icon.png`}
								alt={'Promotion'}
								title={'Promotion'}
							/>
							<h4 className="ph-payment-card-discount-title">¡Descuento!</h4>
						</div>
					)}
				</div>
			</Radio>
		</div>
	);
}
